import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { Dictionary } from 'lodash';
import EyeOutlined from '@ant-design/icons-vue/EyeOutlined';
import FormOutlined from '@ant-design/icons-vue/FormOutlined';
import { IAssignment, IGoodSurveyType, IMedication } from '@tools/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditAssignmentButton',
  props: {
    disabled: { type: Boolean },
    assignment: null,
    goodsMap: null
  },
  emits: ["assignment-edit-click"],
  setup(__props: any) {

const props = __props as {
    disabled: boolean;
    assignment: IAssignment;
    goodsMap: Dictionary<Record<string, any>>;
}





const goodHasDonorsOrSubtypes = (clinicGoodId: number) => {
    const good = props.goodsMap[clinicGoodId];
    return good?.clinicMedications?.some((medication: IMedication) => (
        medication.schemeId !== 1 || medication.allowDonorBiomaterial
    ));
};

const getGoodSurveysWithBiomaterialOptions = (clinicGoodId: number) => {
    const good = props.goodsMap[clinicGoodId];
    if (!good) {
        return [];
    }
    return good.surveyTypes.filter(
        (surveyType: IGoodSurveyType) => surveyType.biomaterial?.length,
    );
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (!__props.assignment.clinicGoodId
            || goodHasDonorsOrSubtypes(__props.assignment.clinicGoodId)
            || getGoodSurveysWithBiomaterialOptions(
                __props.assignment.clinicGoodId
            ).length)
    ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        size: "small",
        "data-test-id": "assignment-edit-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('assignment-edit-click', __props.assignment)))
      }, {
        icon: _withCtx(() => [
          (__props.disabled)
            ? (_openBlock(), _createBlock(_unref(EyeOutlined), { key: 0 }))
            : (_openBlock(), _createBlock(_unref(FormOutlined), { key: 1 }))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})